import React from 'react';
import { ErrorMessage } from '@atlaskit/form';
import { ErrorWrapper } from './questionWrappers';
export const QuestionErrorMsg = ({
  validationErrors
}) => {
  return /*#__PURE__*/React.createElement(ErrorWrapper, null, validationErrors && /*#__PURE__*/React.createElement(ErrorMessage, null, validationErrors.map(validationError => {
    return /*#__PURE__*/React.createElement("span", {
      key: validationError.key
    }, validationError.message, "\xA0");
  }), "\xA0"));
};